module.exports = __webpack_public_path__ + "img/thumbnail_ReticulatedGiraffe_f_normal.821c3218.png";